import React from 'react';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import { operationalStats } from '../../data/site';
export function NumbersStrip() {
  return <section aria-label="How we operate" className="border-y border-hairline bg-surface py-16 lg:py-20" data-id="element-510" data-mp="di4lvm7zvmkd">
      <Container data-id="element-511" data-mp="9gj3xmglsi3b">
        <dl className="grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-512" data-mp="9h2gsorecgah">
          {operationalStats.map((stat, index) => <Reveal key={stat.label} delay={index * 0.06} className="lg:border-l lg:border-hairline lg:pl-6 lg:first:border-l-0 lg:first:pl-0" data-id="element-513" data-mp="4j10ucp9ox38" data-mpi={index}>
              <dt className="text-[32px] leading-[1.1] tracking-[-0.03em] text-ink lg:text-[40px]" data-id="element-514" data-mp="3qp6b0uvu0fdj">
                {stat.value}
              </dt>
              <dd className="mt-3 max-w-[26ch] text-small text-muted" data-id="element-515" data-mp="1ox1c2zfx0htb">{stat.label}</dd>
            </Reveal>)}
        </dl>
      </Container>
    </section>;
}